export enum PlayState {
  play = 'play',
  restart = 'restart',
  reverse = 'reverse',
  restartReverse = 'restartReverse',
  stop = 'stop',
  stopEnd = 'stopEnd',
  pause = 'pause',
  resume = 'resume',
}
